import { render, staticRenderFns } from "./ConstructionSharingDialog.vue?vue&type=template&id=37e98980&scoped=true&"
import script from "./ConstructionSharingDialog.vue?vue&type=script&lang=js&"
export * from "./ConstructionSharingDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionSharingDialog.vue?vue&type=style&index=0&id=37e98980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e98980",
  null
  
)

export default component.exports